import * as dat from 'lil-gui'

export default class GUI extends dat.GUI{
    constructor(){
        super();
    }
    init(){
        this.hide();
    }
}